<template>
  <main class="container-fluid mt-3 bg-white">
    <div class="row h-100 no-gutters pt-5">
      <div class="col-12 mx-lg-auto p-0">
        <div
          class="row no-gutters justify-content-center align-content-start align-content-lg-stretch h-100"
        >
          <div class="col-12 col-xl-2 col-md-3 pt-lg-6 border-right">
            <pc-side-nav :enableProjectFeature="enableProjectFeature"/>
          </div>

          <div class="col-12 col-lg mb-3 mb-lg-5 pt-6">
            <pc-my-trays-conatiner :isAdmin = "user.isAdmin" :user="user" class="pc-my-trays-pages" />
          </div>
        </div>
      </div>
    </div>
  </main>

</template>
<script>
import PcMyTraysConatiner from "./pc-my-trays-conatiner.vue";
import PcSideNav from "./pc-side-nav.vue";
import { mapActions } from "vuex";


export default {
  props:['user', 'enableProjectFeature'],
  data() {
    return {};
  },
  components: {
    PcMyTraysConatiner,
    PcSideNav,
  },
  methods: {
    ...mapActions({getUserInfoEmail :"myTray/userInfoDetails"})
  },
};
</script>
